<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <nav class="navbar bg-white navbar-light mb-2  justify-content-between me-5 me-lg-0">
                <h4>{{ trans(`general.component.profile_widget.invoice_form.title`) }}</h4>
                <a :class="['btn btn-download btn-secondary btn-circle btn-sm', { disabled: isDownloading }]"
                   :href="`/children/${invoice.child_id}/invoice/${invoice.id}/download`" download @click="startDownload">
                    <i class="icon fi fi-rr-download"></i>
                </a>
            </nav>
        </template>
        <template #content>
            <invoice-form :invoice="invoice"/>
        </template>
    </slideout-content>
</template>

<script>

import InvoiceForm from "../molecules/InvoiceForm.vue";
import SlideoutContent from "../../../theme/molecules/SlideoutContent.vue";

export default {
    name: "ChildResourcesPanel",
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    components: {SlideoutContent, InvoiceForm},

    data() {
        return {
            isDownloading: false
        }
    },

    methods: {
        startDownload() {
            this.isDownloading = true;
            setTimeout(()=>  this.isDownloading = false, 8000)
        }
    }
}
</script>
